import type { ReactNode } from 'react';

export const symbol_step_into: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M402-112q-32-32-32-78t32-78q32-32 78-32t78 32q32 32 32 78t-32 78q-32 32-78 32t-78-32Zm48-413v-324q0-13 8.5-21.5T480-879q13 0 21.5 8.5T510-849v324l92-92q9-9 21-9t21 9q9 9 9 21.5t-9 21.5L501-431q-9 9-21 9t-21-9L315-575q-9-9-9-21t9-21q9-9 21-9t21 9l93 92Z"
		/>
	</svg>
);
